var _rect, _polygon, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "#009b3a",
    width: 513,
    height: 342
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fedf00",
    points: "256.5,19.3 461.4,170.7 256.5,322 50.6,170.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002776",
    d: "M215.9,165.7c-13.9,0-27.4,2.1-40.1,6c0.6,43.9,36.3,79.3,80.3,79.3c27.2,0,51.3-13.6,65.8-34.3 C297,185.7,258.7,165.7,215.9,165.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002776",
    d: "M334.9,186c0.9-5,1.5-10.1,1.5-15.4c0-44.4-36-80.4-80.4-80.4c-33.1,0-61.5,20.1-73.9,48.6 c10.9-2.2,22.1-3.4,33.6-3.4C262.5,135.5,304.7,154.9,334.9,186z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BR.80c41d5bd0566f1785093da263ba85b4.svg";